import { Wallet01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Wallet = /* @__PURE__ */ createIcon(Wallet01Icon, 'Wallet');
